import { render, staticRenderFns } from "./TDraftCreate.vue?vue&type=template&id=36a5603e&"
import script from "./TDraftCreate.vue?vue&type=script&lang=js&"
export * from "./TDraftCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a5603e')) {
      api.createRecord('36a5603e', component.options)
    } else {
      api.reload('36a5603e', component.options)
    }
    module.hot.accept("./TDraftCreate.vue?vue&type=template&id=36a5603e&", function () {
      api.rerender('36a5603e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/payments/TDraftCreate.vue"
export default component.exports